<template>
  <section v-if="tickets" id="tickets" class="big spacer half">
    <div class="title" v-html="tickets.title"></div>
    <div class="pt pb" ref="tickets">
      <a target="_blank" :href="tickets.tickets">&rarr; {{ $t("buy") }}</a>
    </div>
    <div class="bt pt" v-if="tickets.anfahrt">
      <a :href="tickets.anfahrt" target="_blank">{{ $t("directions") }}</a>
    </div>
  </section>
</template>

<script>
import API from "@/api/service";
export default {
  data() {
    return {
      tickets: []
    };
  },
  created() {
    API.tickets(this.$i18n.locale).then(page => {
      this.tickets = page.data.result;
    });
  },
};
</script>

<style></style>
